import dayjs from 'dayjs';

import { DATE_TIME_FORMAT, DATE_TIME_SECONDS_FORMAT } from '../constants';
import { SortingBatch } from '../types';
import { isHubDestination } from './sortCodeUtils';

/** 批次时间展示：YYYY/MM/DD HH:mm */
export const formatBatchTime = (time?: number | null): string => (time ? dayjs(time).format(DATE_TIME_FORMAT) : '—');

/** 带秒：YYYY/MM/DD HH:mm:ss */
export const formatBatchTimeSeconds = (time?: number | null): string => (time ? dayjs(time).format(DATE_TIME_SECONDS_FORMAT) : '—');

/** 数字千分位 */
export const formatCount = (n?: number | null): string => (n ?? 0).toLocaleString('en-US');

/** 列表「目的地」列：发出为目的地，接收为「来源 → 目的地」 */
export const flowLabelOf = (b: SortingBatch, inbound: boolean): string => (inbound ? `${b.creationSite} → ${b.destination}` : b.destination || '—');

/** 目的地类型 */
export const destinationTypeOf = (destination: string): 'HUB' | 'WAREHOUSE' => (isHubDestination(destination) ? 'HUB' : 'WAREHOUSE');

/** 包牌标签目的地：配送仓 → `SAN Whs`，Hub → `EWR Hub` */
export const labelDestinationOf = (destination: string): string => {
    const parts = String(destination || '').split('-');
    return parts.length > 1 ? `${parts.slice(1).join('-')} Whs` : `${parts[0]} Hub`;
};
